<div class="modal-header">
    <button class="close" type="button" mat-dialog-close aria-label="Close" ><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title">{{data.dTitle}}</h4>
</div>
<div class="modal-body">
    {{data.dMessage}}
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" mat-dialog-close aria-label="Close" *ngIf="data.dCancelBtnText">{{data.dCancelBtnText}}</button>
        <button class="btn--accent" type="button" [mat-dialog-close]="true">{{data.dOkBtnText}}</button>
    </div>
</div>